import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocsLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.3699 7.90365C17.0581 7.90382 18.285 9.50617 17.8455 11.1353V11.1361L16.4694 16.228C16.1675 17.3466 15.1534 18.125 13.9946 18.125H6.00303C4.91734 18.1247 3.95716 17.4417 3.59255 16.4347L3.52744 16.2288L2.15293 11.1353C1.71357 9.5065 2.94033 7.90403 4.6277 7.90365H15.3699ZM4.6277 9.15365C3.7635 9.15403 3.13461 9.97496 3.3598 10.8097L4.73431 15.9033C4.88907 16.4763 5.40962 16.8747 6.00303 16.875H13.9946C14.5881 16.875 15.1085 16.4768 15.2633 15.9033L16.6386 10.8097C16.8639 9.97502 16.2353 9.15382 15.3699 9.15365H4.6277ZM15.2625 4.68994C15.6077 4.68994 15.8875 4.96979 15.8875 5.31494C15.8875 5.66012 15.6077 5.93994 15.2625 5.93994H4.73431C4.38932 5.93972 4.10931 5.65998 4.10931 5.31494C4.10934 4.96992 4.38934 4.69016 4.73431 4.68994H15.2625ZM12.9668 1.875C13.3119 1.875 13.5918 2.15482 13.5918 2.5C13.5918 2.84518 13.3119 3.125 12.9668 3.125H7.03006C6.68506 3.12478 6.40505 2.84504 6.40505 2.5C6.40505 2.15496 6.68506 1.87522 7.03006 1.875H12.9668Z",
		fill: "currentColor"
	})
});
export default SvgDocsLine;
